import { render, staticRenderFns } from "./sousuoduoxuan.vue?vue&type=template&id=0826c06f&"
import script from "./sousuoduoxuan.vue?vue&type=script&lang=ts&"
export * from "./sousuoduoxuan.vue?vue&type=script&lang=ts&"
import style0 from "./sousuoduoxuan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports